import axios from 'axios'

class CooperantOrdersQueries {
    fetchOrders(queryString = '') {
        const url = `/orders/cooperant-orders${queryString ? (queryString.startsWith('?') ? queryString : `?${queryString}`) : ''}`
        return axios.get(url)
    }

    fetchOrder(orderId) {
        return axios.get(`/orders/cooperant-orders/${orderId}`)
    }

    fetchCooperantDeliveryStatusNames() {
        return axios.get('/deliveries/dicts/cooperant-delivery-statuses')
    }

    addComment(commentData) {
        return axios.post('/orders/cooperant-order-comments', commentData)
    }

    generateCooperantOrdersListReport(queryString = '') {
        const url = `/orders/cooperant-orders?report=true${queryString ? (queryString.startsWith('&') ? queryString : `&${queryString}`) : ''}`
        return axios.get(url)
    }

    printCooperantLabels(payload) {
        return axios.post('/shipments/cooperant-print', payload, {
            responseType: 'arraybuffer'
        })
    }

    provideCooperationShipmentDeliveryNumber(payload) {
        return axios.post('/shipments/cooperant-print', payload)
    }

    updateOrder(orderData) {
        return axios.patch(`/orders/orders-collector/${orderData.id}`, orderData)
    }

    updateDelivery(deliveryId, payload) {
        return axios.patch(`/deliveries/cooperant-delivery/${deliveryId}`, payload)
    }

    deleteOrder(orderId) {
        return axios.delete(`/orders/cooperant-orders/${orderId}`)
    }

    fetchToolboxTemplateContent(toolboxURI, templateId) {
        return axios.get(`${toolboxURI}/patern/${templateId}`, {
            transformRequest(data, headers) {
                if (headers && headers.common && headers.common.Authorization) {
                    delete headers.common.Authorization
                }
                return data
            },
            headers: {
                user: JSON.stringify({
                    name: 'test',
                    email: 'test',
                    production: true
                })
            }
        })
    }
}

export default new CooperantOrdersQueries()
